import React from 'react';

function DashboardHelpInfoTab() {
  return (
    <div style={{ margin: '200px', textAlign: 'center', fontSize: '24px' }}>
      Coming soon...
    </div>
  );
}

export default DashboardHelpInfoTab;
